export const WIZARD_PREFIX = 'Wizard_';
export const SELECTOR_PREFIX = 'Selector_';
export const CONST_PREFIX = 'Const_';
export const ORDER_SUFFIX = '.Order';
export const DEFAULT_SUFFIX = '.Default';
export const NAME_SUFFIX = '.Name';
export const KEY_SUFFIX = '.Key';
